module.exports = __webpack_public_path__ + "img/service-ad-1.47bb3a8a.png";